import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { TaskType } from './taskType.model';
import taskTypeService from './taskType.service';

// namespace
export const TASK_TYPE_STORE_NAMESPACE = 'taskTypeStore';

// state
interface TaskTypeState {
  taskTypes: TaskType[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: TaskTypeState = {
  taskTypes: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<TaskTypeState> = {
  [mutationConstant.FETCH]: (state: TaskTypeState, taskTypes: TaskType[]) => {
    state.taskTypes = taskTypes;
  },
  [mutationConstant.PENDING]: (state: TaskTypeState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: TaskTypeState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: TaskTypeState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch'
};

const action: ActionTree<TaskTypeState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<TaskTypeState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      taskTypeService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  }
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<TaskTypeState, RootState> = {
  [getterConstant.ALL]: (state: TaskTypeState) => state.taskTypes,
  [getterConstant.BY_ID]: (state: TaskTypeState) => (id: number) => state.taskTypes.find(m => m.id === id),
  [getterConstant.STATUS]: (state: TaskTypeState) => state.status,
};

// module
const module: Module<TaskTypeState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const TaskTypeGetter = {
  ALL: `${TASK_TYPE_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${TASK_TYPE_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${TASK_TYPE_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const TaskTypeAction = {
  FETCH: `${TASK_TYPE_STORE_NAMESPACE}/${actionConstant.FETCH}`
};

export default module;
